import React from 'react';
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormROValue from '../../../../library/form/components/FormROValue1';

const UserDeviceEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '370px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Profile Address" />}
        >
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "macAdd" }} value="Device MAC Address" />
                </span>
                <FormInput formObject={formObject} rowKey="" className=""
                    action={{ InputType: "input", paramName: "macAdd" }}
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deviceDetail" }} value="Device Detail" />
                </span>
                <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="82"
                    action={{ paramName: "deviceDetail" }}
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "loginInfo" }} value="Last Logged In" />
                </span>
                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "loginInfo" }}
                    className="uiInline uiHeaderElement"
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Is Active" />
                </span>
                <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proAddMakeDefault"
                    action={{ InputType: "onOff", paramName: "isActive" }}
                />
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isLoggedOn" }} value="Is Logged On" />
                </span>
                <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proAddMakeDefault"
                    action={{ InputType: "onOff", paramName: "isLoggedOn" }}
                />
            </div>
        </FormDialog>
    )
}

export default withView(UserDeviceEditor, "userDevice", "userDevice")
